import { createApiClient } from '@thehotelsnetwork/api-client';

import { apiURL } from '@/config';
import auth from '@/modules/Auth';

export default createApiClient({
  authService: auth,
  httpClientOptions: {
    baseURL: apiURL.base,
  },
  forbiddenResponseCodes: [],
});
